<template>
  <b-modal
    id="insurance-data-modal"
    hide-footer
    hide-header
    centered
    size="lg"
    content-class="p-3 text-center bg-light styled-modal"
    @hidden="$emit('insuranceModalClosed')"
  >
    <div class="row">
      <div class="col-12">
        <div>
          <h4 class="new-modal-title mb-2">
            {{ $t('lang.user.insurance.title') }} 🔒
          </h4>
        </div>

        <div>
          <div>
            <p
              class="mb-2 d-inline-block"
              style="vertical-align: middle"
            >
              {{ $t('lang.user.insurance.text') }}
              <b-link
                v-b-popover.hover.top="$t('lang.user.insurance.insurance_request')"
                class="question-link d-inline-block"
                :title="$t('lang.user.insurance.insurance_request_title')"
              >
                <i class="icon-question" />
              </b-link>
            </p>
          </div>
          <form @submit.prevent="saveUserInsuranceData">
            <div class="col-12 mt-4">
              <Errors :errors="errors" />

              <UserData
                :user-data="userData"
                :fields-to-show="fieldsToShow"
                @fullNameError="userDataError"
                @changes="updateUserData"
              />
            </div>

            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-outline-dark m-2"
                title="button.title"
                @click="$bvModal.hide('insurance-data-modal');"
              >
                {{ $t('lang.user.insurance.close') }}
              </button>
              <button
                id="btn_submit"
                type="submit"
                class="btn btn-main-color m-2 pl-4 pr-4"
                name="btn_submit"
                :disabled="!allowToSend || validated"
              >
                {{ $t('lang.forms.button_save') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import UserData from '@/components/User/UserData';
import Errors from '@/components/Alerts/Errors';
import { API, errorResponse } from '../../api/api';

const UserAPI = API.get('user');

export default {
  name: 'UserInsuranceData',
  components: { Errors, UserData },
  props: {
    userData: {
      type: Object,
      required: true,
    },
    storeCountry: {
      type: String,
      required: false,
    },
    bookingId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      user: {},
      errors: {},
      successMessage: null,
      validated: false,
      allowToSend: true,
    };
  },
  computed: {
    fieldsToShow() {
      const fields = ['full_name', 'doc_type', 'doc_number'];

      if (!this.userData.country) {
        fields.push('nationality');
      }
      return fields;
    },
  },

  watch: {
    userData() {
      // copy avoiding relation. Independent objects.
      this.user = JSON.parse(JSON.stringify(this.userData));
    },
  },
  methods: {
    updateUserData(data) {
      const clave = Object.keys(data)[0];
      const newValue = Object.values(data)[0];

      this.user[clave] = newValue;
    },
    userDataError(value) {
      this.allowToSend = !value;
    },

    async saveUserInsuranceData(e) {
      e.preventDefault();
      this.validated = true;
      this.errors = {};
      const payloadUserInsuranceData = {};
      try {
        payloadUserInsuranceData.booking_id = this.bookingId;
        payloadUserInsuranceData.country = this.user.country;
        this.fieldsToShow.forEach((item) => {
          if (this.user[item] != null) {
            payloadUserInsuranceData[item] = this.user[item];
          }
        });

        await UserAPI.setDataForInsurance(payloadUserInsuranceData);

        await this.$store.dispatch('setDocType', this.user.doc_type);

        this.$bvModal.hide('insurance-data-modal');
        this.$emit('dataLoaded');
      } catch (error) {
        this.validated = false;
        this.errors = errorResponse(error);
      }
      this.validated = false;

      window.scrollTo(0, 0);
    },
  },

};
</script>

<style scoped>
</style>
